var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13.2002V10.5752C18.5 9.68009 18.1444 8.82165 17.5115 8.18871C16.8786 7.55577 16.0201 7.2002 15.125 7.2002H13.625C13.3266 7.2002 13.0405 7.08167 12.8295 6.87069C12.6185 6.65971 12.5 6.37356 12.5 6.0752V4.5752C12.5 3.68009 12.1444 2.82165 11.5115 2.18871C10.8785 1.55577 10.0201 1.2002 9.125 1.2002H7.25M7.25 13.9502H14.75M7.25 16.9502H11M9.5 1.2002H4.625C4.004 1.2002 3.5 1.7042 3.5 2.3252V19.5752C3.5 20.1962 4.004 20.7002 4.625 20.7002H17.375C17.996 20.7002 18.5 20.1962 18.5 19.5752V10.2002C18.5 7.81325 17.5518 5.52406 15.864 3.83623C14.1761 2.14841 11.8869 1.2002 9.5 1.2002Z",
    stroke: "#798CAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.270e1dcc53f35bb885c1b0efb2d0e046.svg";
export { ForwardRef as ReactComponent };